import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import { ThemeProvider } from "styled-components";

import { AuthContextProvider } from "ui/context/auth";
import { RestApiContextProvider } from "ui/context/restApi";
import { lightTheme } from "ui/themes";

interface AppProvidersProps {
  children: React.ReactNode;
}
export const AppProviders = (props: AppProvidersProps) => {
  const { children } = props;
  const queryClient = new QueryClient({
    defaultOptions: { queries: { refetchOnWindowFocus: false } },
  });
  return (
    <QueryClientProvider client={queryClient}>
      <RestApiContextProvider>
        <AuthContextProvider>
          <ThemeProvider theme={lightTheme}>{children}</ThemeProvider>
        </AuthContextProvider>
      </RestApiContextProvider>
    </QueryClientProvider>
  );
};
